module.exports = __webpack_public_path__ + "static/media/2.ab711661.jpg";